module.exports = __webpack_public_path__ + "img/rescope.609c9b2f.png";